import { render } from "./Playlists.vue?vue&type=template&id=9dadc84c&scoped=true"
import script from "./Playlists.vue?vue&type=script&lang=js"
export * from "./Playlists.vue?vue&type=script&lang=js"

import "./Playlists.vue?vue&type=style&index=0&id=9dadc84c&scoped=true&lang=css"

import exportComponent from "/Users/macbook/Mubasher/Mubasher/Projects/Live/bling-rock/Project-Live/soundcode/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9dadc84c"]])

export default __exports__